import React, { useState, useEffect, useRef } from "react";
import {
    Container,
    Row,
    Col,
    Form,
    FormGroup,
    Label,
    Input,
    Button,
    Table,
    Card,
    CardBody, Nav, NavItem, NavLink, TabContent, TabPane, CardHeader
} from "reactstrap";
import TableContainer from "../../../../components/Common/TableContainer";
import Breadcrumbs from "../../../../components/Common/Breadcrumb";
import { useFormik } from "formik";
import * as Yup from "yup";
import getAccessRights from "components/Common/getAccessRights";
import { useLocation, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Swal from 'sweetalert2';
import CustomSelect from "components/Common/custom-select";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import { fetchActiveEmployees, getsalaryscaledate, fetchCategory, fetchDepartment, saveSalaryGeneration, savegeneratesalary, fetchsalarygeneratelog } from "store/actions";
import CustomMonthPicker from "common/CustomMonthPicker";
import CustomDatePicker from "common/CustomDatePicker";
import useButtonAccess from "components/Common/useButtonAccess";
import classnames from "classnames";
import Loader from "common/pageLoader";
import Select from "react-select";
import { showToast, showConfirm } from "../../../../common/Toaster";

const SalaryGeneration = () => {
    const [activeTab, setActiveTab] = useState("EMPLOYEE");
    const dispatch = useDispatch();
    const location = useLocation();   // ✅ declare first
    const history = useHistory();     // ✅ declare first
    const [chklength, setchklength] = useState([]);

    const [accessRight, setAccessRight] = useState(null);
    const [authDetails, setAuthDetails] = useState(null);
    const [data, setData] = useState([]);
    const [isEdit, setIsEdit] = useState(false);
    const [editId, setEditId] = useState(null);
    const [employeeDataSelected, setEmployeeDataSelected] = useState(null);
    const [emp_absentlists, setemp_absentlists] = useState([]);
    const [emp_disprepancy, setemp_disprepancy] = useState([]);
    const [attendancedata, setattendancedata] = useState([]);
    const [discrepancydata, setdiscrepancydata] = useState([]);
    const [emp_employee, setemp_employee] = useState([]);
    const [emp_attendance, setemp_attendance] = useState([]);
    const [emp_payroll, setemp_payroll] = useState([]);

    const [employeeselect, setemployeeselect] = useState(null);
    const [attendanceselect, setattendanceselect] = useState(null);
    const [payrollselect, setpayrollselect] = useState(null);
    const [emp_salarylog, setemp_salarylog] = useState(null);
    useEffect(() => {
        const rights = getAccessRights(location.pathname, history);
        setAccessRight(rights?.data);
    }, [location, history]);
    const { canRead, canCreate, canEdit, canDelete, canApprove } = useButtonAccess(accessRight);

    useEffect(() => {
        const authUserDetails = useAuthUserDetails();
        setAuthDetails(authUserDetails[0])
        const unitId = authUserDetails[0].unit_id
        dispatch(fetchActiveEmployees(unitId));
        dispatch(fetchCategory(authUserDetails[0].unit_id));
        dispatch(fetchDepartment(authUserDetails[0].unit_id));
        dispatch(fetchsalarygeneratelog(authUserDetails[0].unit_id))
    }, [dispatch]);

    const {
        employees,
        categoryList,
        departmentList,
        salarycale,
        salarygenerate,
        emp_salaryinfo,
        emp_negsalaryinfo,
        salarygeneratelogs,
        loading,
        success,
        error,
        saveSuccess,
    } = useSelector((state) => ({
        employees: state.EmployeeDetailsReducer?.employeesActiveList ?? [],
        salarycale: state.PayrollSalaryEmployeeSalaryDefinitionReducer?.salarycale ?? [],
        departmentList: state.EmployeeDetailsReducer?.departmentList ?? [],
        categoryList: state.EmployeeDetailsReducer?.categoryList ?? [],
        salarygenerate: state.PayrollSalaryEmployeeSalaryDefinitionReducer?.salarygenerate ?? [],
        emp_salaryinfo: state.PayrollSalaryEmployeeSalaryDefinitionReducer?.emp_salaryinfo ?? [],
        emp_negsalaryinfo: state.PayrollSalaryEmployeeSalaryDefinitionReducer?.emp_negsalaryinfo ?? [],
        salarygeneratelogs: state.PayrollSalaryEmployeeSalaryDefinitionReducer?.salarygeneratelogs ?? [],
        loading: state.PayrollSalaryEmployeeSalaryDefinitionReducer?.loading,
        error: state.AttendanceLeaveManagReducer?.error,
        success: state.PayrollSalaryEmployeeSalaryDefinitionReducer?.success,
        saveSuccess: state.PayrollSalaryEmployeeSalaryDefinitionReducer?.saveSuccess,
    }));

    let categoryOptions = [], deptOptions = [];

    categoryOptions = (categoryList || []).map(item => ({ label: item.empCategory, value: item.empCatgryid }));
    deptOptions = (departmentList || []).map(item => ({ label: item.departmentcode, value: item.departmentId }));

    useEffect(() => {
        if (success && salarygeneratelogs.length > 0) {
            const generatedData = salarygeneratelogs.map((emp, index) => ({
                sno: index + 1,
                last_rundt: emp.last_rundt,
                salary_month: emp.salary_month,
                from_date: emp.from_date,
                to_date: emp.to_date,
                no_of_days: emp.no_of_days,
                category: emp.category,
                department: emp.department,
                designation: emp.designation,
                employees: emp.employees,
            })) || [];

            setemp_salarylog(generatedData)
        } else {
            setemp_salarylog([])
        }
    }, [salarygeneratelogs, success]);

    const [selectedRowIndex, setSelectedRowIndex] = useState(null);
    const empsalarylogColumns = [
        { Header: "S#", Cell: ({ row }) => emp_salarylog.length - row.index, className: "serial-no", applyHeaderClass: true, },
        { Header: "LAST_RUN_DATE", accessor: "last_rundt" },
        { Header: "SALARY_MONTH", accessor: "salary_month" },
        { Header: "FROM_DATE", accessor: "from_date" },
        { Header: "TO_DATE", accessor: "to_date" },
        { Header: "NO_OF_DAYS", accessor: "no_of_days" },
        { Header: "CATEGORY", accessor: "category" },
        { Header: "DEPARTMENT", accessor: "department" },
        { Header: "DESIGNATION", accessor: "designation" },
        { Header: "EMPLOYEES", accessor: "employees" },
    ];

    useEffect(() => {
        // resetFormData();
        if (success && Array.isArray(salarycale) && salarycale.length > 0) {
            formik.setFieldValue("fromMonth", salarycale[0]?.from_date || "");
            formik.setFieldValue("ToMonth", salarycale[0]?.to_date || "");
            formik.setFieldValue("noOfDays", salarycale[0]?.sal_days || "");
        } else {
            formik.setFieldValue("fromMonth", "");
            formik.setFieldValue("ToMonth", "");
            formik.setFieldValue("noOfDays", "");
        }
    }, [salarycale, success]);

    const formik = useFormik({
        initialValues: {
            salaryMonth: "",
            fromMonth: "",
            ToMonth: "",
            noOfDays: "",
            category: null,
            department: null,
            employee: null
        },
        validationSchema: Yup.object({
            salaryMonth: Yup.string().required("Salary month is required"),
        }),
        validateOnChange: true,
        validateOnBlur: true,
        onSubmit: (values) => {
            // console.log(values);
            const formData = new FormData();
            formData.append("sal_month", values.salaryMonth);
            formData.append("no_of_days", values.noOfDays);
            formData.append("from_date", values.fromMonth);
            formData.append("to_date", values.ToMonth);
            formData.append("cat_id", values?.category?.value || 0);
            formData.append("dept_id", values?.department?.value || 0);
            formData.append("emp_code", values.employee?.value || 0);
            formData.append("unit_id", authDetails?.unit_id);
            formData.append("create_by", authDetails?.user_id);
            dispatch(saveSalaryGeneration(formData));
        },
    });

    useEffect(() => {
        if (!success || !salarygenerate) return;

        if (Array.isArray(salarygenerate.emp_absentlists)) { setemp_absentlists(salarygenerate.emp_absentlists); } else { setemp_absentlists([]); }
        if (Array.isArray(salarygenerate.emp_disprepancy)) { setemp_disprepancy(salarygenerate.emp_disprepancy); } else { setemp_disprepancy([]); }

        if (Array.isArray(salarygenerate.emp_employee)) { setemp_employee(salarygenerate.emp_employee); } else { setemp_employee([]); }
        if (Array.isArray(salarygenerate.emp_attendance)) { setemp_attendance(salarygenerate.emp_attendance); } else { setemp_attendance([]); }
        if (Array.isArray(salarygenerate.emp_payroll)) { setemp_payroll(salarygenerate.emp_payroll); } else { setemp_payroll([]); }
    }, [salarygenerate, success]);

    const handleMonthChange = (date) => {
        const formData = new FormData();
        formData.append("unit_id", authDetails?.unit_id);
        formData.append("saldate", date);
        dispatch(getsalaryscaledate(formData));
    };

    const resetFormData = () => {
        // formik.resetForm();
        dispatch({ type: "RESET_SAVE_STATUS" });
        formik.resetForm({
            values: {
                salaryMonth: "",
                fromMonth: "",
                ToMonth: "",
                noOfDays: "0",
                employee: "",
            },
        });
        formik.validateForm();
        setemployeeselect([]);
        setattendanceselect([]);
        setpayrollselect([]);
    };

    useEffect(() => {
        if (emp_absentlists?.length > 0) {
            const generatedData = emp_absentlists.map((emp, index) => ({
                sno: index + 1,
                emp_no: emp.emp_no,
                emp_name: emp.emp_name,
                emp_id: emp.emp_id,
                department: emp.department,
                group_name: emp.group_name,
                p_date: emp.p_date,
                punch_date: emp.punch_date,
                shift_code: emp.shift_code,
                shift_timings: emp.shift_timings,
                title: emp.title,
                cl_balance: emp.cl_balance,
                wo_balance: emp.wo_balance,
                api_punch_date: emp.api_punch_date,
            })) || [];

            setattendancedata(generatedData);
        } else {
            setattendancedata([]);
        }
    }, [emp_absentlists]);

    const attendanceColumns = [
        { Header: "S.No", Cell: ({ row }) => emp_absentlists.length - row.index, className: "serial-no", applyHeaderClass: true, },
        { Header: "CODE", accessor: "emp_no", width: 10, },
        { Header: "NAME", accessor: "emp_name", width: 60, },
        { Header: "DEPARTMENT", accessor: "department", width: 80, },
        { Header: "DATE", accessor: "punch_date", width: 10, },
        { Header: "CL BAL", accessor: "cl_balance", width: 40, },
        { Header: "WO BAL", accessor: "wo_balance", width: 40, },
        { Header: "SESSION", accessor: "title", width: 40, },
    ];

    useEffect(() => {
        if (emp_disprepancy?.length > 0) {
            const generatedData = emp_disprepancy.map((emp, index) => ({
                sno: index + 1,
                emp_id: emp.emp_id,
                emp_no: emp.emp_no,
                emp_name: emp.emp_name,
                department: emp.department,
                from_date: emp.from_date,
                to_date: emp.to_date,
                title: emp.title,
                leave_id: emp.leave_id,
                leave_status: emp.leave_status,
            })) || [];

            setdiscrepancydata(generatedData);
        } else {
            setdiscrepancydata([]);
        }
    }, [emp_disprepancy]);

    const discrepancyColumns = [
        { Header: "S#", Cell: ({ row }) => discrepancydata.length - row.index, className: "serial-no", applyHeaderClass: true, },
        { Header: "CODE", accessor: "emp_no" },
        { Header: "NAME", accessor: "emp_name" },
        { Header: "DEPARTMENT", accessor: "department" },
        { Header: "FROM_DATE", accessor: "from_date" },
        { Header: "TO_DATE", accessor: "to_date" },
        { Header: "TITLE", accessor: "title" },
        { Header: "STATUS", accessor: "leave_status" },
    ];

    useEffect(() => {
        if (saveSuccess) {
            dispatch({ type: "RESET_SAVE_STATUS" });
            resetFormData();
        }
    }, [saveSuccess, dispatch]);

    const toggle = (tab) => { if (activeTab !== tab) { setActiveTab(tab); } };

    const [isConflict, setisConflict] = useState(false);
    const handleGenerate = () => {
        if (!employeeselect || employeeselect.length === 0) {
            showToast({ icon: "warning", title: "No Selection", text: "Kindly verify and acknowledge the employee abstract." });
            return;
        }

        if (!attendanceselect || attendanceselect.length === 0) {
            showToast({ icon: "warning", title: "No Selection", text: "Kindly verify and acknowledge the Attendance abstract." });
            return;
        }

        if (!payrollselect || payrollselect.length === 0) {
            showToast({ icon: "warning", title: "No Selection", text: "Kindly verify and acknowledge the Payroll abstract." });
            return;
        }

        const hasConflict = emp_payroll.some(row => row.description === "Verdict" && row.total === "CONFLICT");
        setisConflict(hasConflict);
        if (hasConflict) {
            showToast({ icon: "error", title: "Error", text: "Payroll cannot be generated because conflicts exist in the table rows." });
            return;
        }

        const formData = new FormData();
        formData.append("sal_month", formik.values.salaryMonth);
        formData.append("no_of_days", formik.values.noOfDays);
        formData.append("from_date", formik.values.fromMonth);
        formData.append("to_date", formik.values.ToMonth);
        formData.append("cat_id", formik.values?.category?.value || 0);
        formData.append("dept_id", formik.values?.department?.value || 0);
        formData.append("emp_code", formik.values.employee?.value || 0);
        formData.append("unit_id", authDetails?.unit_id);
        formData.append("create_by", authDetails?.user_id);
        dispatch(savegeneratesalary(formData));
    }

    const CustomSelect = ({
        closeMenuOnScroll = true,
        menuPortalTarget = document.body,
        menuPosition = "fixed",
        menuShouldScrollIntoView = false,
        ...props
    }) => {
        return (
            <Select
                {...props}
                closeMenuOnScroll={closeMenuOnScroll}
                menuPortalTarget={menuPortalTarget}
                menuPosition={menuPosition}
                menuShouldScrollIntoView={menuShouldScrollIntoView}
                styles={{
                    menuPortal: (base) => ({
                        ...base,
                        zIndex: 9999,
                    }),
                }}
            />
        );
    };

    return (
        <React.Fragment>
            <Loader loading={loading} />
            <div className="page-content">
                <Container fluid>
                    <Breadcrumbs title="Payroll / Salary" breadcrumbItem="Salary Generation" />

                    <Row>
                        <Col lg="12">
                            <Card>
                                <CardBody>

                                    <Form onSubmit={formik.handleSubmit}>
                                        <Row className="mb-3">
                                            <Col md={3}>
                                                <FormGroup>
                                                    <Label for="salaryMonth">Salary Month <span className="text-danger">*</span></Label>
                                                    <CustomMonthPicker
                                                        name="salaryMonth"
                                                        value={formik.values.salaryMonth}
                                                        onChange={(date) => {
                                                            formik.setFieldValue("salaryMonth", date);
                                                            formik.setFieldTouched("salaryMonth", true, true); // force validation
                                                            handleMonthChange(date);
                                                        }}
                                                        onBlur={() => formik.setFieldTouched("salaryMonth", true)}
                                                    />

                                                    {formik.touched.salaryMonth && formik.errors.salaryMonth && (
                                                        <div className="text-danger">{formik.errors.salaryMonth}</div>
                                                    )}
                                                </FormGroup>
                                            </Col>

                                            <Col md={3}>
                                                <FormGroup>
                                                    <Label for="noOfDays">No of Days</Label>
                                                    <Input
                                                        type="number"
                                                        disabled
                                                        name="noOfDays"
                                                        value={formik.values.noOfDays}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        invalid={formik.touched.noOfDays && Boolean(formik.errors.noOfDays)}
                                                    />
                                                </FormGroup>
                                            </Col>

                                            <Col md={3}>
                                                <FormGroup>
                                                    <Label for="fromDate">From Date <span className="text-danger">*</span></Label>
                                                    <CustomDatePicker
                                                        name="fromMonth"
                                                        disabled
                                                        value={formik.values.fromMonth}
                                                        onChange={(date) => formik.setFieldValue("fromMonth", date)}
                                                        onBlur={formik.handleBlur}
                                                        className={`form-control ${formik.touched.fromMonth && formik.errors.fromMonth ? "is-invalid" : ""}`}
                                                    />
                                                </FormGroup>
                                            </Col>

                                            <Col md={3}>
                                                <FormGroup>
                                                    <Label for="toDate">To Date <span className="text-danger">*</span></Label>
                                                    <CustomDatePicker
                                                        name="ToMonth"
                                                        disabled
                                                        value={formik.values.ToMonth}
                                                        onChange={(date) => formik.setFieldValue("ToMonth", date)}
                                                        onBlur={formik.handleBlur}
                                                        className={`form-control ${formik.touched.ToMonth && formik.errors.ToMonth ? "is-invalid" : ""}`}
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Col md={3}>
                                                <FormGroup>
                                                    <Label for="category">Category</Label>
                                                    <CustomSelect
                                                        id="category"
                                                        name="category"
                                                        isMulti={false}
                                                        options={categoryOptions || []}
                                                        value={formik.values.category || null}
                                                        onChange={(selectedOption) => {
                                                            formik.setFieldValue("category", selectedOption);
                                                        }}
                                                        onBlur={() => formik.setFieldTouched("category", true)}
                                                        className="react-select-container"
                                                        classNamePrefix="react-select"
                                                        isClearable={true}
                                                        closeMenuOnScroll={false}
                                                        menuPosition="absolute"
                                                        menuPortalTarget={null}
                                                    />
                                                    {formik.touched.category && formik.errors.category && (
                                                        <div className="text-danger">{formik.errors.category}</div>
                                                    )}
                                                </FormGroup>
                                            </Col>

                                            <Col md={3}>
                                                <FormGroup>
                                                    <Label for="employeeCode">Employee Code</Label>
                                                    <CustomSelect
                                                        id="employee"
                                                        name="employee"
                                                        isMulti={false}
                                                        options={employees}
                                                        value={employeeDataSelected}
                                                        onChange={(selectedOption) => {
                                                            // resetFormData();
                                                            setEmployeeDataSelected(selectedOption);
                                                            formik.setFieldValue("employee", selectedOption);
                                                        }}
                                                        onBlur={() => formik.setFieldTouched("employee", true)}
                                                        className="react-select-container"
                                                        classNamePrefix="react-select"
                                                        isClearable={true}
                                                        closeMenuOnScroll={false}
                                                        menuPosition="absolute"
                                                        menuPortalTarget={null}
                                                    />
                                                    {formik.touched.employee && formik.errors.employee && (
                                                        <div className="text-danger">{formik.errors.employee}</div>
                                                    )}
                                                </FormGroup>
                                            </Col>

                                            <Col md={3}>
                                                <FormGroup>
                                                    <Label for="department">Department</Label>
                                                    <CustomSelect
                                                        id="department"
                                                        name="department"
                                                        isMulti={false}
                                                        options={deptOptions || []}
                                                        value={formik.values.department || null}
                                                        onChange={(selectedOption) => {
                                                            formik.setFieldValue("department", selectedOption);
                                                        }}
                                                        onBlur={() => formik.setFieldTouched("department", true)}
                                                        className="react-select-container"
                                                        classNamePrefix="react-select"
                                                        isClearable={true}
                                                        closeMenuOnScroll={false}
                                                        menuPosition="absolute"
                                                        menuPortalTarget={null}
                                                    />

                                                    {formik.touched.department && formik.errors.department && (
                                                        <div className="text-danger">{formik.errors.department}</div>
                                                    )}
                                                </FormGroup>
                                            </Col>

                                            <Col md={3} className="text-end d-flex align-items-center justify-content-end gap-2 mt-3">
                                                <Button type="submit" color="primary" className="px-3 d-flex align-items-center"><i className="fas fa-search me-2"></i> SEARCH </Button>
                                                {emp_employee?.length > 0 && emp_attendance?.length > 0 && emp_payroll?.length > 0 && (
                                                    <Button type="button" color="success" className="px-3 d-flex align-items-center" onClick={handleGenerate}><i className="fas fa-save me-2"></i> GENERATE</Button>)}
                                                <button
                                                    type="button"
                                                    className="btn btn-secondary"
                                                    onClick={() => {
                                                        showConfirm({
                                                            title: "Are you sure?", text: "Do you want to Cancel?", confirmText: "Yes, Cancel", cancelText: "No", onConfirm: () => {
                                                                resetFormData();
                                                            }
                                                        });
                                                    }}
                                                >
                                                    <i className="fas fa-sync me-1" /> Cancel
                                                </button>


                                            </Col>
                                        </Row>
                                    </Form>
                                </CardBody>
                            </Card>
                            {emp_employee?.length > 0 && emp_attendance?.length > 0 && emp_payroll?.length > 0 && (
                                <>
                                    <Card>
                                        <CardBody>
                                            <Row>
                                                <Col md={12}>
                                                    <Card>
                                                        <CardHeader className="bg-primary text-white">
                                                            ABSTRACT
                                                        </CardHeader>

                                                        <CardBody>

                                                            {/* ✅ Add Nav */}
                                                            <Nav tabs>
                                                                <NavItem>
                                                                    <NavLink
                                                                        className={classnames({ active: activeTab === "EMPLOYEE" })}
                                                                        onClick={() => toggle("EMPLOYEE")}
                                                                        style={{ cursor: "pointer" }}
                                                                    >
                                                                        Employee


                                                                    </NavLink>
                                                                </NavItem>

                                                                <NavItem>
                                                                    <NavLink
                                                                        className={classnames({ active: activeTab === "ATTENDANCE" })}
                                                                        onClick={() => toggle("ATTENDANCE")}
                                                                        style={{ cursor: "pointer" }}
                                                                    >
                                                                        Attendance
                                                                    </NavLink>
                                                                </NavItem>

                                                                <NavItem>
                                                                    <NavLink
                                                                        className={classnames({ active: activeTab === "PAYROLL" })}
                                                                        onClick={() => toggle("PAYROLL")}
                                                                        style={{ cursor: "pointer" }}
                                                                    >
                                                                        Payroll
                                                                    </NavLink>
                                                                </NavItem>
                                                            </Nav>

                                                            {/* ✅ Tab Content */}
                                                            <TabContent activeTab={activeTab} className="mt-3">

                                                                {/* EMPLOYEE TAB */}
                                                                <TabPane tabId="EMPLOYEE">
                                                                    <Table bordered striped hover responsive className="align-middle text-center custom-table">
                                                                        <thead className="table-light">
                                                                            <tr>
                                                                                <th className="px-4 py-3">S#</th>
                                                                                <th className="px-4 py-3 text-start">DESCRIPTION</th>
                                                                                <th className="px-4 py-3">TOTAL</th>
                                                                            </tr>
                                                                        </thead>

                                                                        <tbody>
                                                                            {emp_employee && emp_employee.length > 0 ? (
                                                                                emp_employee.map((row, index) => (
                                                                                    <tr key={index}>
                                                                                        <td className="px-4 py-3">{index + 1}</td>
                                                                                        <td className="px-4 py-3 text-start">{row.description}</td>
                                                                                        <td className="px-4 py-3 fw-semibold">
                                                                                            {row.total}
                                                                                        </td>
                                                                                    </tr>
                                                                                ))
                                                                            ) : (
                                                                                <tr>
                                                                                    <td colSpan="3" className="text-center py-4 text-muted">
                                                                                        No Records Found
                                                                                    </td>
                                                                                </tr>
                                                                            )}
                                                                        </tbody>
                                                                    </Table>
                                                                    <Label className="mb-0 d-flex align-items-center">
                                                                        <Input type="checkbox" id="chkemployee" className="me-2"
                                                                            checked={formik.values.chkemployee}
                                                                            onChange={(e) => setemployeeselect(e.target.checked)}
                                                                        />
                                                                        <span className="text-danger"> I approve the payroll for this period and confirm that all employee-related inputs have been reviewed and verified as accurate.</span>
                                                                    </Label>
                                                                </TabPane>


                                                                {/* ATTENDANCE TAB */}
                                                                <TabPane tabId="ATTENDANCE">
                                                                    <Table bordered striped hover responsive className="align-middle text-center custom-table">
                                                                        <thead className="table-light">
                                                                            <tr>
                                                                                <th className="px-4 py-3">S#</th>
                                                                                <th className="px-4 py-3 text-start">DESCRIPTION</th>
                                                                                <th className="px-4 py-3">TOTAL</th>
                                                                            </tr>
                                                                        </thead>

                                                                        <tbody>
                                                                            {emp_attendance && emp_attendance.length > 0 ? (
                                                                                emp_attendance.map((row, index) => (
                                                                                    <tr key={index}>
                                                                                        <td className="px-4 py-3">{index + 1}</td>
                                                                                        <td className="px-4 py-3 text-start">{row.description}</td>
                                                                                        <td className="px-4 py-3 fw-semibold">
                                                                                            {row.total}
                                                                                        </td>
                                                                                    </tr>
                                                                                ))
                                                                            ) : (
                                                                                <tr>
                                                                                    <td colSpan="3" className="text-center py-4 text-muted">
                                                                                        No Records Found
                                                                                    </td>
                                                                                </tr>
                                                                            )}
                                                                        </tbody>
                                                                    </Table>
                                                                    <Label className="mb-0 d-flex align-items-center">
                                                                        <Input type="checkbox" id="chkemployee" className="me-2"
                                                                            checked={formik.values.chkattendance}
                                                                            onChange={(e) => setattendanceselect(e.target.checked)}
                                                                        />
                                                                        <span className="text-danger"> I approve the payroll for this period and confirm that all Attendance-related inputs have been reviewed and verified as accurate.</span>
                                                                    </Label>
                                                                </TabPane>


                                                                {/* PAYROLL TAB */}
                                                                <TabPane tabId="PAYROLL">
                                                                    <Table bordered striped hover responsive className="align-middle text-center custom-table">
                                                                        <thead className="table-light">
                                                                            <tr>
                                                                                <th className="px-4 py-3">S#</th>
                                                                                <th className="px-4 py-3 text-start">DESCRIPTION</th>
                                                                                <th className="px-4 py-3">TOTAL</th>
                                                                            </tr>
                                                                        </thead>

                                                                        <tbody>
                                                                            {emp_payroll && emp_payroll.length > 0 ? (
                                                                                emp_payroll.map((row, index) => {
                                                                                    const isConflict = emp_payroll.some(row => row.description === "Verdict" && row.total === "CONFLICT");
                                                                                    return (
                                                                                        <tr key={index}>
                                                                                            <td className="px-4 py-3">{index + 1}</td>
                                                                                            <td className="px-4 py-3 text-start">{row.description}</td>
                                                                                            <td
                                                                                                style={{
                                                                                                    color: isConflict ? "red" : "inherit",
                                                                                                    fontWeight: isConflict ? "bold" : "normal"
                                                                                                }}
                                                                                            >
                                                                                                {row.total}
                                                                                            </td>
                                                                                        </tr>
                                                                                    );
                                                                                })
                                                                            ) : (
                                                                                <tr>
                                                                                    <td colSpan="3" className="text-center py-4 text-muted">
                                                                                        No Records Found
                                                                                    </td>
                                                                                </tr>
                                                                            )}
                                                                        </tbody>
                                                                    </Table>
                                                                    <Label className="d-flex align-items-start gap-2 mb-0">
                                                                        <Input
                                                                            type="checkbox"
                                                                            id="chkemployee"
                                                                            name="chkpayroll"
                                                                            className="mt-1"
                                                                            checked={formik.values.chkpayroll}
                                                                            onChange={(e) => setpayrollselect(e.target.checked)}
                                                                        />

                                                                        <span className="text-danger">
                                                                            I approve the payroll for this period and confirm that all
                                                                            Attendance-related inputs have been reviewed and verified as accurate.
                                                                        </span>

                                                                    </Label>
                                                                </TabPane>

                                                            </TabContent>
                                                        </CardBody>
                                                    </Card>
                                                </Col>
                                            </Row>
                                        </CardBody>
                                    </Card>

                                </>
                            )}

                            {emp_salaryinfo?.length > 0 && (
                                <Card>
                                    <CardBody>
                                        <Row>
                                            <Col md={12}>
                                                <Table bordered striped hover responsive className="align-middle text-center custom-table">
                                                    <thead className="table-light">
                                                        <tr>
                                                            <th>Salary Month</th>
                                                            <th>Total Employees</th>
                                                            <th>Total Net Pay</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {emp_salaryinfo.map((row, index) => (
                                                            <tr key={index}>
                                                                <td>{row.salary_month}</td>
                                                                <td>{row.total_employees}</td>
                                                                <td>{row.total_netpay}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </Table>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            )}

                            {emp_negsalaryinfo?.length > 0 && (
                                <Card>
                                    <CardBody>
                                        <Row>
                                            <Col md={12}>
                                                <Table bordered striped hover responsive className="align-middle text-center custom-table">
                                                    <thead className="table-light">
                                                        <tr>
                                                            <th>CODE</th>
                                                            <th>NAME</th>
                                                            <th>DEPARTMENT</th>
                                                            <th>LOP</th>
                                                            <th>GROSS</th>
                                                            <th>NETPAy</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {emp_negsalaryinfo.map((row, index) => (
                                                            <tr key={index}>
                                                                <td>{row.emp_no}</td>
                                                                <td>{row.emp_name}</td>
                                                                <td>{row.department}</td>
                                                                <td>{row.lop_days}</td>
                                                                <td>{row.gross}</td>
                                                                <td>{row.net_pay}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </Table>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            )}
                            {(emp_absentlists?.length > 0 || discrepancydata?.length > 0) && (
                                <>
                                    <h5 className="text-primary mb-2 mb-md-0">Absent Details</h5>
                                    <Card>
                                        <CardBody>
                                            {/* Tables Section */}
                                            <Row>
                                                <Col md={12}>
                                                    <TableContainer
                                                        columns={attendanceColumns}
                                                        data={emp_absentlists}
                                                        isGlobalFilter={false}
                                                        customPageSize={10}
                                                        isPagination={false}
                                                        className="custom-header-css"
                                                    />
                                                </Col>
                                            </Row>
                                        </CardBody>
                                    </Card>
                                    <h5 className="text-primary mb-2 mb-md-0">Discrepancy Details</h5>
                                    <Card>
                                        <CardBody>
                                            <Row>
                                                {/* Discrepancy Details Table */}
                                                <Col md={12}>

                                                    <TableContainer
                                                        columns={discrepancyColumns}
                                                        data={discrepancydata}
                                                        isGlobalFilter={false}
                                                        customPageSize={10}
                                                        className="custom-header-css"
                                                    />
                                                </Col>
                                            </Row>
                                        </CardBody>
                                    </Card>
                                </>
                            )}
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <h5 className="text-primary mb-2 mb-md-0">Salary Generation Logs</h5>
                            <Card>
                                <CardBody>
                                    <Row>
                                        {/* Discrepancy Details Table */}
                                        <Col md={12}>
                                            <TableContainer
                                                columns={empsalarylogColumns}
                                                data={emp_salarylog || []}
                                                isGlobalFilter={false}
                                                customPageSize={10}
                                                className="custom-header-css"
                                            />
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>

        </React.Fragment>

    );
};

export default SalaryGeneration;
